<!-- visitor/src/components/V2/shell/MessagesView.vue -->
<template>
    <div class="sps-messages">
        <ShellHeader variant="plain" :title="$t('shell.messages')" @close="minimize" />
        <div v-if="detailId" class="sps-messages__detail">
            <button type="button" class="sps-messages__back" @click="detailId = null">‹ {{ $t("shell.messages") }}</button>
            <div v-if="detailLoading" class="sps-messages__empty">…</div>
            <p v-else-if="detailError" class="sps-messages__empty">{{ $t("shell.loadFailed") }}</p>
            <ChatHistoryDetail v-else :colors="colors" :message-styling="true" :messages="detailMessages" :participants="[]" />
        </div>
        <div v-else class="sps-messages__list">
            <div v-if="!loaded" class="sps-messages__empty">…</div>
            <div v-else-if="!conversations.length" class="sps-messages__empty">{{ $t("shell.noConversations") }}</div>
            <div v-if="loaded && conversations.length > 1" class="sps-messages__search">
                <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>
                <input v-model="query" type="search" :placeholder="$t('shell.messagesSearch')" />
            </div>
            <div v-if="loaded && conversations.length && !visible.length" class="sps-messages__empty">{{ $t("shell.helpEmpty") }}</div>
            <button v-for="c in visible" :key="c._id" type="button" class="sps-messages__item" @click="select(c)">
                <span class="sps-messages__avatar"><img v-if="avatarOf(c)" :src="avatarOf(c)" alt="" /><span v-else>{{ initialOf(titleOf(c)) }}</span></span>
                <span class="sps-messages__info">
                    <span class="sps-messages__top"><span class="sps-messages__name">{{ titleOf(c) }}</span><span class="sps-messages__time">{{ relativeTime(c.createdDate, $i18n.locale) }}</span></span>
                    <span class="sps-messages__preview" v-if="previewOf(c)">{{ previewOf(c).text }}</span>
                </span>
                <span v-if="isUnread(c, lastRead)" class="sps-messages__dot" aria-hidden="true"></span>
            </button>
        </div>
        <button v-if="!detailId" type="button" class="sps-messages__cta" @click="$emit('ask')">{{ hasActiveChat ? $t("shell.continueChat") : $t("shell.startNew") }}</button>
    </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import _ from "lodash";
import ShellHeader from "./ShellHeader.vue";
import ChatHistoryDetail from "../ChatHistoryDetail.vue";
import request from "../../../utils/request";
import dateUtils from "../../../utils/DateUtil";
import { pickPreview, conversationTitle, initialOf, relativeTime } from "../../../utils/chatHistoryList";
import { convertHistoryMessages } from "../../../utils/convertHistoryMessages";
import { isUnread } from "../../../utils/shell/unread";
import { filterConversations } from "../../../utils/shell/conversationSearch";
import { sendMinimizeAction } from "../../../utils/parentWindowConnection";
export default {
    name: "ShellMessagesView",
    components: { ShellHeader, ChatHistoryDetail },
    props: { colors: { type: Object, default: () => ({}) } },
    data() { return { detailId: null, detailMessages: [], detailLoading: false, detailError: false, query: "" }; },
    computed: {
        ...mapState({ conversations: (s) => s.shell.conversations, loaded: (s) => s.shell.conversationsLoaded, lastRead: (s) => s.shell.lastRead, conversationId: (s) => s.chat.conversationId }),
        ...mapGetters({ hasActiveChat: "shell/hasActiveChat" }),
        visible() { return filterConversations(this.conversations, this.query, (c) => this.titleOf(c)); },
    },
    methods: {
        isUnread, initialOf, relativeTime,
        titleOf(c) { return conversationTitle(c, () => this.$t("shell.supportTeam")); },
        // sohbet surerken uretilen ara ozet yerine son mesaj gosterilir; ozet kapaninca (final) gecerli
        previewOf(c) { return (c.ai && c.ai.summary && c.ai.final !== false) ? { text: c.ai.summary, mine: false } : pickPreview(c.messages); },
        avatarOf(c) { return _.get(c, "users[0].gravatar") || null; },
        minimize() { sendMinimizeAction(); },
        select(c) {
            this.$store.dispatch("shell/markRead", c._id);
            if (c._id === this.conversationId) { this.$emit("open-chat"); return; }
            this.detailId = c._id;
            this.detailLoading = true;
            this.detailError = false;
            // Gecmis mesajlar salt okunur; ChatHistoryListTwo ile ayni uc ve donusum
            request({ url: `/conversations/${c._id}/messages`, method: "get" }).then((r) => {
                const items = _.orderBy(_.uniqBy(r.data.data, (q) => q.uniqMessageId || q._id), (q) => new Date(q.createdDate).getTime(), "asc");
                this.detailMessages = convertHistoryMessages(items, dateUtils.formatHour);
            }).catch(() => { this.detailError = true; this.detailMessages = []; }).finally(() => { this.detailLoading = false; });
        },
    },
    mounted() { dateUtils.initializeLocale(this.$i18n.locale); this.$store.dispatch("shell/loadConversations").catch(() => {}); },
};
</script>
<style lang="scss">
.sps-messages { display: flex; flex-direction: column; height: 100%; background: var(--background-color-first, #fff); color: var(--primary-text, #1f2337); position: relative;
    &__list, &__detail { flex: 1; overflow: auto; padding-bottom: 64px; }
    &__back { margin: 8px 12px; border: 0; background: transparent; color: var(--button-color, #4f46e5); font: inherit; cursor: pointer; }
    &__search { display: flex; align-items: center; gap: 8px; margin: 12px 14px 4px; padding: 0 12px; border: 1px solid var(--sps-border, rgba(15, 23, 42, 0.12)); border-radius: 12px; background: var(--sps-surface, #fff);
        svg { width: 18px; height: 18px; fill: none; stroke: currentColor; stroke-width: 1.8; stroke-linecap: round; opacity: 0.5; flex-shrink: 0; }
        input { flex: 1; min-width: 0; border: 0; background: transparent; padding: 10px 0; font: inherit; font-size: 13.5px; color: inherit; outline: none; }
        &:focus-within { border-color: var(--button-color, #4f46e5); box-shadow: 0 0 0 3px color-mix(in srgb, var(--button-color, #4f46e5) 14%, transparent); } }
    &__empty { padding: 48px 24px; text-align: center; opacity: 0.6; font-size: 13.5px; }
    &__item { display: flex; align-items: center; gap: 12px; width: 100%; padding: 12px 16px; border: 0; border-bottom: 1px solid var(--sps-border, rgba(15, 23, 42, 0.06)); background: transparent; color: var(--primary-text, #1f2337); font: inherit; text-align: left; cursor: pointer; &:hover { background: var(--sps-border, rgba(15, 23, 42, 0.04)); } }
    &__avatar { flex: none; width: 38px; height: 38px; border-radius: 50%; overflow: hidden; background: var(--button-color, #4f46e5); color: #fff; display: inline-flex; align-items: center; justify-content: center; font-weight: 600; img { width: 100%; height: 100%; object-fit: cover; } }
    &__info { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
    &__top { display: flex; justify-content: space-between; gap: 8px; }
    &__name { font-size: 14px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    &__time { font-size: 11px; color: var(--sps-muted, rgba(15, 23, 42, 0.5)); white-space: nowrap; }
    &__preview { font-size: 12.5px; color: var(--sps-muted, rgba(15, 23, 42, 0.65)); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    &__dot { width: 8px; height: 8px; border-radius: 50%; background: #ef4444; flex: none; }
    &__cta { position: absolute; left: 50%; bottom: 14px; transform: translateX(-50%); padding: 10px 18px; border: 0; border-radius: 999px; background: var(--button-color, #1f2337); color: var(--button-text-color, #fff); font: inherit; font-size: 13px; font-weight: 600; box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25); cursor: pointer; }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/shell/MessagesView.vue